<template>
  <!-- 问答讨论 / 问答讨论详情 -->
  <div class="qa-reply-dialog">
    <!-- 顶部标题与回复按钮 -->
    <div class="reply-header">
      <div class="qa-title">互动问答回复</div>
      <el-button type="primary" class="reply-btn" @click="replybt">回复</el-button>
    </div>

    <!-- 问题详情 -->
    <div class="question-card">
      <div class="question-main">
        <div class="qa-icon">
        </div>
        <div class="question-content">
          <div class="question-title-row">

            <span class="question-title">{{ item.title }}</span>
            <div class="question-tags">
              <span v-if="item.is_top === 1" class="q-tag tag-top">置顶</span>
              <span v-if="item.is_teacher_join === 1" class="q-tag tag-teacher">教师参与</span>
              <span v-if="Number(item.has_publish) === 0" class="q-tag tag-pending">待审核</span>
            </div>
          </div>
          <div class="question-body">
            <vue-markdown :source="htmlDecode(item.content)"></vue-markdown>
          </div>
          <div class="question-meta">
            <div class="meta-left">
              <el-image class="reply-avatar small" :src="item.avatar">
                <template slot="error">
                  <el-image :src="avater1"></el-image>
                </template>
              </el-image>
              <span class="author-name">

                {{ item.author_name }}</span>
              <span class="publish-time">{{ item.created_at }} 发布</span>
            </div>
            <div class="meta-right">
              <div class="stat-item">
                <img class="stat-icon" :src="view_d" />
                <span class="stat-num">{{ item.view_count }}</span>
              </div>
              <div class="stat-item" @click="setParentLike(item)">
                <img class="stat-icon" :src="item.like_status === 1 ? like_c : like_d" />
                <span class="stat-num">{{ item.like_count }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 回复输入框 -->
    <div v-if="dialogVisible" class="reply-editor">
      <Tinymce ref="editor" v-model="queryParams.content" style="height: auto; border-radius: 8px" @setInput="getValue">
      </Tinymce>
      <div class="editor-actions">
        <el-button @click="canclebt">取消</el-button>
        <el-button type="primary" class="submit-btn" @click="submitbt('{}')">确定</el-button>
      </div>
    </div>

    <!-- 回复总数 -->
    <div class="reply-divider">
      <div class="divider-line"></div>
      <div class="divider-text">共{{ total }}条回复</div>
      <div class="divider-line"></div>
    </div>

    <!-- 回复列表 -->
    <div class="reply-list" v-if="delReset">
      <div class="reply-item" v-for="(item, index) in replylist" :key="index">
        <div class="reply-item-main">
          <el-image class="reply-avatar" :src="item.avatar">
            <template slot="error">
              <el-image :src="avater1"></el-image>
            </template>
          </el-image>
          <div class="reply-body">
            <div class="reply-header-line">
              <div class="reply-user">
                <span class="user-name">{{ item.user_name }}</span>
                <span v-if="item.to_user_name" class="reply-to">回复 {{ item.to_user_name }}</span>
                <span class="reply-time">{{ item.created_at | commFormat }}</span>
                <span v-if="Number(item.has_publish) === 0" class="q-tag tag-pending">待审核</span>
              </div>
              <div class="reply-actions">
                <div class="stat-item" @click="setlike(item)">
                  <img class="stat-icon" :src="item.like_status === 1 ? like_c : like_d" />
                  <span class="stat-num">{{ item.like_count }}</span>
                </div>
                <div class="stat-item" @click="childreply(item)">
                  <img class="stat-icon" :src="review_d" />
                  <span class="stat-num">{{ item.reply_count }}</span>
                </div>
                <div class="stat-item" @click="deletreply(item)" v-if="item.is_mine == 1">
                  <img class="stat-icon" :src="del_d" />
                </div>
              </div>
            </div>
            <div class="reply-text" v-html="htmlDecode(item.content)"></div>
          </div>
        </div>

        <!-- 回复输入框 -->
        <div v-if="item.replylistflag" class="reply-editor nested">
          <Tinymce ref="editor" v-model="queryParams.content" style="height: auto; border-radius: 8px"
            @setInput="getValue">
          </Tinymce>
          <div class="editor-actions">
            <el-button @click="canclefollowUp(item)">取消</el-button>
            <el-button type="primary" class="submit-btn" @click="followupsubmint(item)">确定</el-button>
          </div>
        </div>

        <!-- 子回复 -->
        <div class="reply-children" v-if="item.child && item.child.length > 0">
          <div class="reply-item child" v-for="(item1, index) in item.child" :key="index">
            <div class="reply-item-main">
              <el-image class="reply-avatar small" :src="item1.avatar">
                <template slot="error">
                  <el-image :src="avater1"></el-image>
                </template>
              </el-image>
              <div class="reply-body">
                <div class="reply-header-line">
                  <div class="reply-user">
                    <span class="user-name">{{ item1.user_name }}</span>
                    <span v-if="item1.to_user_name" class="reply-to">回复 {{ item1.to_user_name }}</span>
                    <span class="reply-time">{{ item1.created_at | commFormat }}</span>
                    <span v-if="Number(item1.has_publish) === 0" class="q-tag tag-pending">待审核</span>
                  </div>
                  <div class="reply-actions">
                    <div class="stat-item" @click="setlike(item1)">
                      <img class="stat-icon" :src="item1.like_status === 1 ? like_c : like_d" />
                      <span class="stat-num">{{ item1.like_count }}</span>
                    </div>
                    <div class="stat-item" @click="childreply1(item1)">
                      <img class="stat-icon" :src="review_d" />
                    </div>
                    <div class="stat-item" @click="deletchildreply(item1)" v-if="item1.is_mine == 1">
                      <img class="stat-icon" :src="del_d" />
                    </div>
                  </div>
                </div>
                <div class="reply-text" v-html="htmlDecode(item1.content)"></div>
              </div>
            </div>

            <!-- 子回复输入框 -->
            <div v-if="item1.replylistflag1" class="reply-editor nested">
              <Tinymce ref="editor" v-model="queryParams.content" style="height: auto; border-radius: 8px"
                @setInput="getValue">
              </Tinymce>
              <div class="editor-actions">
                <el-button @click="canclefollowUp(item1)">取消</el-button>
                <el-button type="primary" class="submit-btn" @click="followupsubmint1(item1)">确定</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="elpagination">
        <div class="elpagination-title">共{{ total }}条</div>
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="10"
          :current-page="queryParams.page" @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// import Customdialog from "@/components/customdialog.vue";
import { autoImgCorrection } from "@/utils/index"
import VueMarkdown from 'vue-markdown'
import { setQaLike } from "@/api/qa"
import {
  getQaReplyList,
  addQaReplyAdd,
  setQaReplyLike,
  QaReplyDelete,
  qareply_deatil,
} from "@/api/qareply"
import dayjs from "dayjs"
import Tinymce from "@/components/VueTinymce/index.vue"

export default {
  name: "courselearning",
  components: { Tinymce, VueMarkdown },
  data() {
    return {
      dialogVisible: false,
      view_d: require("@/assets/course/UIout/QA/QA_ico_preview.png"),
      like_c: require("@/assets/course/UIout/QA/QA_ico_like.png"),
      like_d: require("@/assets/course/UIout/QA/QA_ico_like.png"),
      review_d: require("@/assets/course/UIout/QA/QA_ico_question.png"),
      avater1: require("@/assets/course/UIout/QA/QA_ico_name.png"),
      item: '',
      replylist: [],
      total: 0,
      queryParams: {
        qa_reply_id: '',
        qa_id: '',
        content: '',
        per_page: 10, // 每页条数
        page: 1,
      },
      delReset: true
    }
  },
  filters: {
    dataformat: function (value) {
      if (!value) return ""
      return dayjs.unix(value).format("mm")
    },
    commFormat: function (value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss")
    },
  },
  watch: {
    replylist: {
      handler(newV) {
        this.$emit('childReset', true)
        this.delReset = false
        this.$nextTick(() => {
          this.delReset = true
        })
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    qa_id() {
      return this.$route.query.qa_id
    },
    id() {
      return this.$route.query.id
    },
  },
  created() {
    // this.queryParams.qa_id = this.qa_id
    // this.initdata();
    // this.getqareplylist({ qa_id: this.qa_id });
  },
  methods: {
    initdata(obj) {
      this.item = obj
      this.queryParams.qa_id = obj.id
      this.getqareplylist({ qa_id: obj.id })
    },
    // 主体详情
    initInfo() {
      qareply_deatil({ id: this.qa_id }).then((res) => {
        if (res.code === 0) {
          this.item = res.data
        }
      })
    },
    getqareplylist(params) {
      getQaReplyList(params)
        .then((response) => {
          if (response.data.data && response.data.data.length > 0) {
            response.data.data.forEach(item => {
              this.$set(item, "replylistflag", false)
              if (item.child.length > 0) {
                item.child.forEach(el => {
                  this.$set(el, "replylistflag1", false)
                })
              }
            })
          }
          this.total = response.data.total
          this.replylist = response.data.data
          console.log(this.replylist, "this.replylist");

        })
        .catch((error) => {
          //console.log(error);
        })
    },
    pageChange(val) {
      this.queryParams.page = val
      this.getqareplylist(this.queryParams)
    },
    setParentLike(data) {
      this.item.like_status = this.item.like_status === 1 ? 0 : 1
      this.item.like_count = this.item.like_status ? this.item.like_count + 1 : this.item.like_count - 1
      this.setQaLike({ id: data.id })
    },
    setQaLike(params) {
      setQaLike(params)
        .then((response) => {
          if (response.code === 0) {
            this.getqareplylist({ qa_id: this.queryParams.qa_id })
          }
        })
        .catch((error) => { })
    },
    setlike(item) {
      this.setQaReplyLike({
        id: item.id,
      })
    },

    setQaReplyLike(params) {
      setQaReplyLike(params)
        .then((response) => {
          if (response.code === 0) {
            this.getqareplylist({ qa_id: this.queryParams.qa_id })
          }
        })
        .catch((error) => {
          //console.log(error);
        })
    },
    deletreply(item) {
      this.$confirm("此操作将永久删除该评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.QaReplyDelete({
            id: item.id,
          })
          this.$message({
            type: "success",
            message: "删除成功!",
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    deletchildreply(item) {
      this.$confirm("此操作将永久删除该评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.QaReplyDelete({
            id: item.id,
          })
          this.$message({
            type: "success",
            message: "删除成功!",
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    QaReplyDelete(params) {
      QaReplyDelete(params)
        .then((response) => {
          if (response.code === 0) {
            // this.$message.success("删除成功")
            this.getqareplylist({ qa_id: this.queryParams.qa_id })
          }
        })
        .catch((error) => {
          //console.log(error);
        })
    },
    toback() {
      this.$router.push({
        path: "/home/virtualsimulationexperiment/experimentdetails",
        query: {
          id: this.id,
          btid: 7,
          returncomid: "Interactiveanswer",
        },
      })
    },
    replybt() {
      this.dialogVisible = !this.dialogVisible
      this.queryParams.qa_reply_id = ''
      this.queryParams.content = ''
    },
    canclebt() {
      this.dialogVisible = false
    },
    //取消追评
    canclefollowUp(row) {
      row.replylistflag = false
    },
    //追评
    followupsubmint(row) {
      // this.queryParams.qa_id = row.id
      this.submitbt(row)
      row.replylistflag = false
      this.queryParams.content = ''
    },
    childreply(item) {
      this.queryParams.qa_reply_id = item.id
      this.queryParams.content = ''
      item.replylistflag = !item.replylistflag
    },
    //追评回复
    childreply1(item) {
      item.replylistflag1 = !item.replylistflag1
      this.queryParams.content = ''
    },
    //追评回复
    followupsubmint1(row) {
      this.queryParams.qa_reply_id = row.id
      this.submitbt(row)
      row.replylistflag1 = false
      this.queryParams.content = ''
    },
    submitbt(data) {
      if (this.queryParams.content === "") {
        if (data === '{}') {
          this.dialogVisible = false
        }
        return false
      }
      addQaReplyAdd(this.queryParams)
        .then((response) => {
          if (response.code === 0) {
            this.$message.success("回复成功")
            this.dialogVisible = false
            this.getqareplylist({ qa_id: this.queryParams.qa_id })
          }
        })
        .catch((error) => {
          //console.log(error);
        })
    },
    // 获取富文本得值
    getValue(data) {
      this.queryParams.content = data
    },
    htmlDecode(text) {
      const that = this
      if (text) {
        let textContent = text.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/\\/g, '');
        textContent.replace(/<img.+?>/ig, function (matchImg, captureImg) {
          let resImgSrc = matchImg.replace("../uploads", that.$api.baseUrl + "/uploads").replace(/\\/g, '') // 自定义变量接收图片
          text = textContent.replace(matchImg, resImgSrc)
        })
        textContent.replace(/<video(([\s\S])*?)<\/video>/gi, function (matchImg, captureImg) {
          let resVideoSrc = matchImg.replace("../uploads", that.$api.baseUrl + "/uploads").replace(/\\/g, '') // 自定义变量接收图片
          text = textContent.replace(matchImg, resVideoSrc)
        })
        textContent.replace(/<p>([^<]*?)<\/p>/gi, function (matchImg) {
          let resPSrc = matchImg.replace(/<p>([^<]*?)<\/p>/gi, '$1').replace(/\\/g, '') // 自定义变量接收图片
          text = textContent.replace(matchImg, resPSrc)
        })
      }
      return text
    },
  },
};
</script>
<style scoped lang="scss">
.qa-reply-dialog {
  padding: 24px;
  background: #ffffff;

  .reply-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .qa-title {
      font-size: 20px;
      font-weight: 600;
      color: #333333;
    }

    .reply-btn {
      background: #6a5af9;
      border-color: #6a5af9;
      border-radius: 20px;
      padding: 9px 24px;

      &:hover {
        background: #7b6cfa;
        border-color: #7b6cfa;
      }
    }
  }

  .question-card {
    padding: 20px;
    background: rgba(248, 247, 255, 0.8);
    border: 1px solid #edeaff;
    border-radius: 16px;
    margin-bottom: 20px;

    .question-main {
      display: flex;
      gap: 16px;

      .qa-icon {
        width: 30px;
        height: 30px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url(~@/assets/course/UIout/QA/QA_ico_question.png) no-repeat center center;
        background-size: contain;
      }



      .question-content {
        flex: 1;
        min-width: 0;

        .question-title-row {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 12px;

          .question-title {
            font-size: 17px;
            font-weight: 600;
            color: #333333;
          }

          .question-tags {
            display: flex;
            gap: 8px;

            .q-tag {
              padding: 2px 8px;
              font-size: 12px;
              border-radius: 4px;

              &.tag-top {
                color: #0fbf7f;
                background: rgba(15, 191, 127, 0.1);
                border: 1px solid #0fbf7f;
              }

              &.tag-teacher {
                color: #6a5af9;
                background: rgba(106, 90, 249, 0.1);
                border: 1px solid #6a5af9;
              }

              &.tag-pending {
                color: #f13218;
                background: rgba(241, 50, 24, 0.1);
                border: 1px solid #f13218;
              }
            }
          }
        }

        .question-body {
          font-size: 14px;
          color: #666666;
          line-height: 1.8;
          word-break: break-word;
          word-wrap: break-word;

          ::v-deep p {
            margin: 0 0 8px 0;
          }

          ::v-deep img {
            max-width: 100%;
            height: auto;
          }
        }

        .question-meta {
          margin-top: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 12px;

          .meta-left {
            display: flex;
            align-items: center;
            gap: 10px;



            .author-avatar {
              width: 28px;
              height: 28px;
              border-radius: 50%;

              ::v-deep img {
                border-radius: 50%;
              }
            }

            .author-name {
              font-size: 14px;
              color: #333333;
            }

            .publish-time {
              font-size: 13px;
              color: #999999;
            }
          }

          .meta-right {
            display: flex;
            align-items: center;
            gap: 20px;
          }
        }
      }
    }
  }

  .reply-editor {
    margin-bottom: 20px;
    padding: 16px;
    background: #f9f9ff;
    border: 1px solid #e8e6ff;
    border-radius: 12px;

    &.nested {
      margin-left: 50px;
      margin-top: 12px;
    }

    .editor-actions {
      margin-top: 12px;
      display: flex;
      justify-content: flex-end;
      gap: 12px;

      .submit-btn {
        background: #6a5af9;
        border-color: #6a5af9;

        &:hover {
          background: #7b6cfa;
          border-color: #7b6cfa;
        }
      }
    }
  }

  .reply-divider {
    display: flex;
    align-items: center;
    gap: 16px;
    margin: 24px 0;

    .divider-line {
      flex: 1;
      height: 1px;
      background: #D1CAFC;
    }

    .divider-text {
      font-size: 14px;
      color: #999999;
      white-space: nowrap;
    }
  }

  .reply-list {
    .reply-item {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #D1CAFC;

      &:last-child {
        border-bottom: none;
      }

      &.child {
        margin-bottom: 12px;
        padding-bottom: 12px;
        border-bottom: 1px dashed #f0f0f0;
      }

      .reply-item-main {
        display: flex;
        gap: 12px;

        .reply-avatar {
          width: 40px;
          height: 40px;
          flex-shrink: 0;
          border-radius: 50%;
          overflow: hidden;

          ::v-deep img {
            border-radius: 50%;
            object-fit: cover;
          }

          &.small {
            width: 32px;
            height: 32px;
          }
        }

        .reply-body {
          flex: 1;
          min-width: 0;

          .reply-header-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px;
            margin-bottom: 8px;

            .reply-user {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: 10px;

              .user-name {
                font-size: 15px;
                font-weight: 600;
                color: #333333;
              }

              .reply-to {
                font-size: 13px;
                color: #999999;
              }

              .reply-time {
                font-size: 13px;
                color: #999999;
              }
            }

            .reply-actions {
              display: flex;
              align-items: center;
              gap: 16px;
            }
          }

          .reply-text {
            font-size: 14px;
            color: #555555;
            line-height: 1.8;
            word-break: break-word;
            word-wrap: break-word;

            ::v-deep p {
              margin: 0 0 6px 0;
            }

            ::v-deep img {
              max-width: 100%;
              height: auto;
            }
          }
        }
      }
    }

    .reply-children {
      margin-left: 52px;
      margin-top: 16px;
      padding-left: 16px;
      // border-left: 2px solid #edeaff;
    }
  }

  .stat-item {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;

    .stat-icon {
      width: 18px;
      height: 18px;
    }

    .stat-num {
      font-size: 13px;
      color: #999999;
    }

    &:hover .stat-num {
      color: #6a5af9;
    }
  }

  .elpagination {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    .elpagination-title {
      margin-right: 10px;
      font-size: 14px;
      color: #666666;
    }
  }
}

/* 响应式 */
@media screen and (max-width: 768px) {
  .qa-reply-dialog {
    padding: 12px;

    .reply-header {
      .qa-title {
        font-size: 16px;
      }

      .reply-btn {
        padding: 7px 18px;
        font-size: 13px;
      }
    }

    .question-card {
      padding: 12px;

      .question-main {
        gap: 10px;

        .question-icon {
          width: 36px;
          height: 36px;

          i {
            font-size: 18px;
          }
        }

        .question-content {
          .question-title-row {
            .question-title {
              font-size: 15px;
            }

            .question-tags {
              .q-tag {
                font-size: 11px;
                padding: 1px 6px;
              }
            }
          }

          .question-body {
            font-size: 13px;
            line-height: 1.6;
          }

          .question-meta {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;

            .meta-left {
              .author-avatar {
                width: 24px;
                height: 24px;
              }

              .author-name {
                font-size: 13px;
              }

              .publish-time {
                font-size: 12px;
              }
            }
          }
        }
      }
    }

    .reply-editor {
      padding: 12px;

      &.nested {
        margin-left: 30px;
      }

      .editor-actions {
        .submit-btn {
          padding: 7px 18px;
          font-size: 13px;
        }
      }
    }

    .reply-list {
      .reply-item {
        padding-bottom: 12px;

        .reply-item-main {
          gap: 10px;

          .reply-avatar {
            width: 32px;
            height: 32px;

            &.small {
              width: 28px;
              height: 28px;
            }
          }

          .reply-body {
            .reply-header-line {
              flex-direction: column;
              align-items: flex-start;
              gap: 4px;

              .reply-user {
                .user-name {
                  font-size: 14px;
                }

                .reply-time {
                  font-size: 12px;
                }
              }
            }

            .reply-text {
              font-size: 13px;
              line-height: 1.6;
            }
          }
        }

        .reply-children {
          margin-left: 30px;
          padding-left: 10px;
        }
      }
    }
  }

  .elpagination {
    margin-top: 24px;
    flex-wrap: wrap;
    gap: 8px;

    .elpagination-title {
      font-size: 13px;
      width: 100%;
      text-align: center;
      margin-right: 0;
      margin-bottom: 4px;
    }

    ::v-deep .el-pagination {
      .btn-prev,
      .btn-next,
      .el-pager li {
        min-width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .qa-reply-dialog {
    padding: 8px;

    .reply-header {
      .qa-title {
        font-size: 15px;
      }
    }

    .question-card {
      padding: 10px;

      .question-main {
        .question-icon {
          width: 32px;
          height: 32px;
        }

        .question-content {
          .question-title-row {
            .question-title {
              font-size: 14px;
            }
          }

          .question-body {
            font-size: 12px;
          }
        }
      }
    }

    .reply-list {
      .reply-item {
        .reply-item-main {
          .reply-avatar {
            width: 28px;
            height: 28px;
          }

          .reply-body {
            .reply-header-line {
              .reply-user {
                .user-name {
                  font-size: 13px;
                }
              }
            }

            .reply-text {
              font-size: 12px;
            }
          }
        }

        .reply-children {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
